


















import Vue from 'vue'
import models from '@/mixins/models-mixin'
import Group, { GroupQuery } from '@/types/Group.interface'
import moment from 'moment-timezone'
import GroupQueryConstructor from '@/components/GroupQueryConstructor.vue'
export default Vue.extend({
    mixins: [models],
    components: { GroupQueryConstructor },
    data() {
        return {
            //  Determine if the buttons are disabled
            disabled: true
        }
    },
    computed: {
        personsQueryFilter: {
            get(): GroupQuery {
                return this.$store.getters.contactsPersonsQueryFilter
            },
            set(val: GroupQuery) {
                this.$store.commit('contactsPersonsQueryFilterSet', val)
            }
        },
        userHasPermission(): Function {
            return this.$store.getters.userHasPermission
        }
    },
    methods: {
        onClearFilter(): void {
            //  Reset 'personsQueryFilter'
            this.personsQueryFilter = { exceptions: [], queries: [] }

            //  Submit to reset the query
            this.$emit('submit', this.personsQueryFilter)
        },
        async onClose(): Promise<void> {
            //  If a query was NOT selected, do nothing
            if (!this.personsQueryFilter) return

            //  Else, the query was changed, publish the selected query filter (we use 'submit' since it is the generic event handler in DialogApp.vue)
            this.$emit('submit', this.personsQueryFilter)
        },
        onQuerySelected(query: GroupQuery): void {
            //  Persist the selected query in the vuex store
            this.personsQueryFilter = query
        },
        onQueryValidated(bool: boolean): void {
            //  Update the buttons disabled status
            this.disabled = !bool
        },
        onSaveAsGroup(query: GroupQuery): void {
            //  Create a new query group
            const group = this.newQueryGroup()

            //  Set the new group's query
            group.query = query

            //  Assemble a group name input
            const input = {
                type: 'TEXT',
                title: 'Group Name',
                name: 'Group Name',
                label: 'Group Name',
                path: 'name',
                validate: 'required|max:45'
            }

            //  Pop an AppForm to capture the group name
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Group Name',
                icon: 'mdi-account-multiple-plus',
                component: 'app-form',
                props: {
                    model: group,
                    inputs: [input],
                    alwaysSubmit: true
                },
                callback: async (group: Group) => {
                    //  Close all APP dialogs
                    this.$store.commit('dialogCloseAll', 'APP')

                    //  if the group does NOT have a name, create one
                    if (!group.name) {
                        //  Get current datetime
                        const d = this.$options.filters.chatDate(moment.now())

                        //  Attach a group name
                        group.name = `Filtered Contacts (${d})`
                    }

                    //  Post the group to the database
                    const response = await this.$store.dispatch('groupsPost', group)

                    //  If the request failed do nothing
                    if (!response) return

                    //  Navigate to the selected group
                    this.$router.push(`/groups/${response.id}`)
                }
            })
        }
    }
})
